import React from "react";

export function CamelotIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7334 22V13.78C15.6972 13.99 17.0298 14.89 17.0298 14.89L18.2823 13.48C16.2283 12.02 13.1823 11.96 13.1823 11.96L12.6813 6.44C13.012 6.22 13.2324 5.85 13.2324 5.42C13.2324 4.75 12.6813 4.2 12.01 4.2C11.3387 4.2 10.7876 4.75 10.7876 5.42C10.7876 5.85 11.0081 6.23 11.3387 6.44L10.8377 11.96C10.8377 11.96 7.79177 12.01 5.73775 13.48L6.9902 14.89C6.9902 14.89 8.32281 13.99 10.2866 13.78V22C2.61164 16.32 1.9804 8.07 2.00044 5.33C2.00044 4.76 2.34111 4.24 2.86213 4.01C4.39513 3.33 7.89197 2 12 2C16.108 2 19.6049 3.33 21.1379 4.01C21.6589 4.24 21.9996 4.76 21.9996 5.33C22.0196 8.07 21.3884 16.32 13.7334 22Z"
        fill="white"
      />
    </svg>
  );
}
